import Vue from 'vue'
import VueRouter from 'vue-router'
//import authentication from '@/services/auth.service.js'
import config from '@/config/config.json'


//https://www.thepolyglotdeveloper.com/2017/11/router-navigate-pages-vuejs-application/
//https://rimorsoft.com/tutorial-sobre-vue-router
//https://flaviocopes.com/vue-router/
Vue.use(VueRouter)

  const routes = [
    {
      path: "/",
      component: () => import("@/views/Index.vue"),      
      name: "Index",
      meta: { }
    },
    {
      path: "/authredirect",
      component: () => import("@/views/AuthRedirect.vue"),      
      name: "AuthRedirect",
      meta: { }
    },
    {
      path: "/:pid/challenges/:chid/ideas/:iid",
      component: () => import("@/views/ViewIdea.vue"),
      props: true,
      name: "Idea",
      meta: { requiresAuthentication: true, requirePID: true }
    },
    {
      path: "/:pid/challenges/:chid",
      component: () => import("@/views/ViewIdea.vue"),
      props: true,
      name: "Challenge",
      meta: { requiresAuthentication: true, requirePID: true }
    },
    {
      path: "/:pid",
      component: () => import("@/views/Challenges.vue"),
      props: true,
      name: "Challenges",
      meta: { requiresAuthentication: true, requirePID: true }
    }
]

const router = new VueRouter({
  //render: h => h(App),
  routes,
  base: config.deployment.basepath,
  linkActiveClass: "active"
})


// Global route guard
router.beforeEach((to, from, next) => {
  console.log("beforeEach " + to.path);
  if (to.matched.some(record => record.meta.requiresAuthentication)) {
    let authentication = Vue.prototype.$AuthService;
    // this route requires auth, check if logged in    

    if (authentication.isAuthenticated()) {
      // only proceed if authenticated.
      if (!to.meta.requirePID) {
        next();
      } else {
        let { unique_name } = authentication.getUserProfile();
        let allowedPID = unique_name.split('@')[1];
        let pid = to.params.pid;
        //si hay un pid y coincide con la organización del usuario o es la demo (todos pueden acceder a la demo)
        if (pid && (allowedPID == pid || pid.toLowerCase() == "demo")) {
          next();
        } else {         
          router.push({ name: "Index", meta: { headerName: "Index", redirection: true }});
        }
      }
    } else {
      localStorage.auth_redirect_uri = to.path;
      authentication.signIn();
    }
  } else {
    //gestiona el redirect uri cuando el usuario ha logado en una pagina, para llevarle donde queria
    if (to.name == "Index" && localStorage.auth_redirect_uri) {
      let intentedUri = localStorage.auth_redirect_uri;
      delete localStorage.auth_redirect_uri;
      router.push(intentedUri);
    } else {
      next();
    }
  }
});


export default router
